export interface BrowserObservationTime {
  readonly clockId: string
  readonly observedAtMs: number
  readonly monotonicMs: number
}

let clockId: string | undefined
let sequence = 0

export function withBrowserObservationClock(time: Omit<BrowserObservationTime, 'clockId'>): BrowserObservationTime {
  clockId ??= crypto.randomUUID()
  return {...time, clockId}
}

export function browserObservationTime(): BrowserObservationTime {
  return withBrowserObservationClock({observedAtMs: Date.now(), monotonicMs: performance.now()})
}

export function nextBrowserObservationSequence(): number {
  return sequence++
}
